// 商品管理定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 起订条件
 */
class InitCondition extends UltMeta {
    AMOUNT = new Meta(1, "起订金额");
    TON = new Meta(2, "起订吨数");
}

export const INIT_CONDITION = new InitCondition();

/**
 * 支付方式
 */

class PayType extends UltMeta {
    CASH = new Meta(1, "现金");
    LETTER_OF_CREDIT = new Meta(2, "信用证");
    BANKER_ACCEPTANCE = new Meta(3, "银行承兑汇票");
    COMMERCIAL_ACCEPTANCE = new Meta(4, "商业承兑汇票");
    BANK_TRANSFER = new Meta(5, "银行转账");
}

export const PAY_TYPE = new PayType();

/**
 * 履约保证金类型
 */
class PerformanceBondType extends UltMeta {
    AMOUNT = new Meta(1, "按金额");
    PERCENT = new Meta(2, "按百分比");
}

export const PERFORMANCE_BOND_TYPE = new PerformanceBondType();

/**
 * 商品状态
 */
class State extends UltMeta {
    UP_SHELF = new Meta(1, "上架");
    DOWN_SHELF = new Meta(2, "下架", "color-info");
}

export const STATE = new State();

/**
 * 审核状态
 */
class AuditState extends UltMeta {
    NOT_AUDIT = new Meta(1, "待审核");
    FAIL = new Meta(2, "未通过");
    PASS = new Meta(3, "已发布");
    DOWN_SHELF = new Meta(4, "已下架");
    CLOSE = new Meta(5, "已关闭");
}

export const AUDIT_STATE = new AuditState();

/**
 * 供应商类型
 * */
class SupplierType extends UltMeta {
    RETAIL_TRADER = new Meta(1, "贸易商/零售");
    DIRECT_OPERATION_OF_MINING_PLANT = new Meta(2, "矿厂直营");
}
export const SUPPLIER_TYPE = new SupplierType();

/**
 * 价格类型
 * */
class PriceType extends UltMeta {
    ORIGIN_SHIP_PRICE = new Meta(1, "产地上船价");
    WU_HU_PORT_SALE_PRICE = new Meta(2, "芜湖港销售价");
    JIANG_YIN_PORT_SALE_PRICE = new Meta(3, "江阴港销售价");
    WU_HU_PORT_PRICE = new Meta(4, "芜湖靠港价");
    JIANG_YIN_PORT_PRICE = new Meta(5, "江阴靠港价");
}
export const PRICE_TYPE = new PriceType();

/**
 * 交易大厅：商品列表、采购需求
 * */
class TradeType extends UltMeta {
    PRODUCT_LIST = new Meta(1, "商品列表");
    PURCHASING_DEMAND = new Meta(2, "采购需求");
}
export const TRADE_TYPE = new TradeType();

/**
 * 商品详情页面浏览来源页面枚举
 */
class ProductViewType extends UltMeta {
    HOME_RECOMMEND = new Meta(1, "首页推荐");
    FIND_GOODS = new Meta(2, "找货源列表");
    SEARCH_RESULT = new Meta(3, "搜索结果");
}
export const PRODUCT_VIEW_TYPE = new ProductViewType();

/**
 * 商品类型枚举
 */
class ProductType extends UltMeta {
    CONSIGNMENT_PRODUCTS = new Meta(1, "寄售商品");
    GROUP_BUYING_PRODUCTS = new Meta(2, "团购商品");
    PICKING_UP_MISSING_PRODUCTS = new Meta(3, "捡漏商品");
    ACTIVITY_PRODUCTS = new Meta(4, "活动商品");
}
export const PRODUCT_TYPE = new ProductType();

/**
 * 商品库存枚举
 */
class HasStockStatus extends UltMeta {
    IN_STOCK = new Meta(1, "有货");
    OUT_OF_STOCK = new Meta(2, "无货");
    OFF_SHELF = new Meta(3, "下架");
}
export const HAS_STOCK_STATUS = new HasStockStatus();